import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import { Form } from 'semantic-ui-react';
import cx from 'classnames';

export const ReferenceDropdown = ({
  title,
  value,
  refs,
  onChange,
  width,
  withPlaceholder,
  disabled,
}) => {
  const renderDefault = () => {
    const selectedValue = refs.find(r => r.id === value);
    if (value && selectedValue) {
      return <div className="text">{selectedValue.label}</div>;
    }
    return <div className="default text">{withPlaceholder ? title : ''}</div>;
  };

  const itemClassName = id => {
    const active = value === id;
    return cx('item', {
      active: active,
      selected: active,
    });
  };

  const renderItem = item => (
    <div key={item.id} data-value={item.id} className={itemClassName(item.id)}>
      {item.label}
    </div>
  );

  const onDropdownChange = (value, text, choice) => {
    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      onChange(choice, { value: undefined });
    } else {
      onChange(choice, { value: parsedValue });
    }
  };

  return (
    <Form.Field width={width}>
      <label>{title}</label>
      <Dropdown
        value={value}
        canDelete={value !== undefined && value !== null}
        items={refs}
        renderDefault={renderDefault}
        renderItem={renderItem}
        onChange={onDropdownChange}
        disabled={disabled}
      />
    </Form.Field>
  );
};

ReferenceDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number,
  refs: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  withPlaceholder: PropTypes.bool,
};

ReferenceDropdown.default = {
  withPlaceholder: true,
};

export default ReferenceDropdown;



// WEBPACK FOOTER //
// ./src/modules/common/components/ReferenceDropdown.js